import {ExpandableMarker} from '@/utils/gmaps/expandable.marker';
import {IconMarker} from '@/utils/gmaps/icon.marker';

export interface MarkerService<T extends DisguiseDto.IGMapsMarkerContent> {

    generateMarkerContent(config: T): Node | null;

    /**
     * User clicked into map
     */
    onClick(
      markerConfig: DisguiseDto.GMapsMarker,
      marker: google.maps.marker.AdvancedMarkerElement,
      allMarkers: google.maps.marker.AdvancedMarkerElement[],
      gmapsView: google.maps.Map
    ): void;

    /**
     * User requested details outside of the map
     */
    onUserRequestedDetails(
      markerConfig: DisguiseDto.GMapsMarker,
      marker: google.maps.marker.AdvancedMarkerElement,
      allMarkers: google.maps.marker.AdvancedMarkerElement[],
      gmapsView: google.maps.Map
    ): void;

}

const GMAPS_MARKER_REGISTRY: Partial<Record<DisguiseDto.IGMapsMarkerContent['@type'], MarkerService<DisguiseDto.IGMapsMarkerContent>>> = {
    Icon: new IconMarker(),
    ExpandableMarkerContent: new ExpandableMarker(),
};

export {
    GMAPS_MARKER_REGISTRY
};
